import { getWindow } from '@/helpers/globals'

const window = getWindow()

export const getUri = (): string => window?.location?.href || ''
